import { render, staticRenderFns } from "./cell-action-download.vue?vue&type=template&id=58e7c579&scoped=true"
import script from "./cell-action-download.ts?vue&type=script&lang=ts&external"
export * from "./cell-action-download.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-action-download.vue?vue&type=style&index=0&id=58e7c579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7c579",
  null
  
)

export default component.exports